import { createAsyncThunk } from '@reduxjs/toolkit'
import okHttp from '@helper/okHttp'
import { goods, user, getTypePrefix } from '@/api'

/**
 * 获取商品详情
 * @returns {Promise<void>}
 */
export const getGoodsDetailAction = createAsyncThunk(
    getTypePrefix(goods.getGoodsDetail),
    async (params) => await okHttp(goods.getGoodsDetail, {
        method: 'GET',
        params
    })
)

/**
 *  获取会员等级列表
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */
export const getMemberLevelListAction = createAsyncThunk(
    getTypePrefix(`${user.getMemberLevelList}_Goods_Detail`),
    async (params) => await okHttp(user.getMemberLevelList, {
        method: 'GET',
	    params
    })
)
